<template>
	<v-header title="体检预约" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<Row justify="center" align="middle">
				<Col flex="70px" style="padding-left: 5px; ">体检单</Col>
				<Col flex="auto" style="font-weight: bold;padding-left: 5px; ">{{model.patientTitle}}</Col>
				<Col flex="70px" style="padding-left: 5px;"><Button @click="view.showDrawerPatient=true">选择</Button>
				</Col>
			</Row>
			<Row justify="center" align="middle">
				<Col flex="70px" style="padding-left: 5px;">体检日期</Col>
				<Col flex="auto" style="padding-left: 5px; "><Input v-model="model.examinateTime" placeholder="选择体检日期"
					disabled style="width: 100%" /></Col>
				<Col flex="70px" style="padding-left: 5px;"><img src="../../static/img/ai.png"
					style="width:30px;height: 30px;" @click="queueAI" /></Col>
			</Row>
			<div style="font-size:12px;">
				<v-calendar :markDateMore="departQueuePoolList"
					v-on:choseDay="calendarClick">
				</v-calendar>
				<Divider>注意事项</Divider>
				<div class="ivu-m-16" v-html="this.infoNote"></div>
			</div>
			<Drawer title="选择体检单" placement="bottom" :mask-closable="false" height="80%"
				v-model="view.showDrawerPatient">
				<List size="small" class="suiteMain">
					<ListItem v-for="item in patientList">
						<ListItemMeta :title="item.patientName" :description="item.patient"
							@click="patientCheck(item)" />
						<template #action>
							<li>
								<Text type="danger">
									<Numeral :value="item.amount" format="0,0.00">
										<template #prefix>
											<strong>¥</strong>
										</template>
									</Numeral>
								</Text>
							</li>
						</template>
					</ListItem>
				</List>
			</Drawer>
			<Drawer title="预约列表" placement="bottom" :mask-closable="false" height="100%" v-model="view.showQueueModal" 
			@on-close="queueModalColse">
				<List size="small" class="suiteMain">
					<ListItem v-for="item in queueList" >
						<ListItemMeta :title="item.departName"
							:description="converterEx.toDateTimeString(item.appointmentTime)"
							@click="patientCheck(item)" />
						<template #action>
							<li>
								{{item.queueNo}}
							</li>
						</template>
					</ListItem>
				</List>
				<FooterToolbar>
					<Button type="warning" @click="queueModalColse">关闭</Button>
				</FooterToolbar>
			</Drawer>
		</div>
	</div>
</template>
<script>
	import header from "@/components/header/index";
	import calendar from "@/components/calendar/calendar.vue";
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'depart',
		data() {
			return {
				view: {
					showDrawerPatient: false,
					showExamFeeItem: false,
					showQueueModal: false,
				},
				patientList: [],
				departQueuePoolList: [],
				model: {
					patientTitle: "请选择",
					patient: "",
					examinateTime: ""
				},
				queueList: [],
				infoNote: "", //注意事项
			};
		},
		created() {
			this.model.patient=this.$route.query.Patient;
			this.getAppointmentInfoNote();
			this.patientSearch();
		},
		methods: {
			patientSearch() {
				var that=this;
				sysPost(that,{
					"url": 'Queue/PatientList',
					"data": {}
				},function(result){
					that.patientList = result;
					if(!that.isNullOrEmptyEx(that.model.patient)){
						var patient=that.model.patient;
						var item=that.patientList.find(function(p){ return p.patient==patient})
						that.patientCheck(item)
					}
				})
			},
			patientCheck(item) {
				this.model.patientTitle = item.patientName + "/" + item.patient;
				this.model.patient = item.patient;
				this.view.showDrawerPatient = false;
				this.departQueuePoolSearch(item.patient);
			},
			departQueuePoolSearch(patient) {
			  var that=this;
				sysPost(that,{
					"url": 'Queue/DepartQueuePoolList',
					"data": {
						"Patient": patient
					}
				},function(result){
					that.departQueuePoolList = result;
				})
			},
			calendarClick(data) {
				var that=this;
				var dateString= this.converterEx.toStringEx(new Date(parseFloat(new Date(data).getTime())),"yyyy-MM-dd");
				if(this.departQueuePoolList.existsEx(function(p){ return that.converterEx.toDateString(p.dateTime)==dateString}))this.model.examinateTime = dateString
				else this.model.examinateTime = "";
			},
			queueAI() {
				if(this.isNullOrEmptyEx(this.model.patient)){
					this.$Message.error('体检单不能为空!');
					return false;
				}
				else if(this.isNullOrEmptyEx(this.model.examinateTime)){
					this.$Message.error('体检日期不能为空!');
					return false;
				}
				var that=this;
				sysPost(that,{
					"url": 'Queue/QueueAI',
					"data": {
						"Patient": this.model.patient,
						"ExaminateTime": this.model.examinateTime
					}
				},function(result){
					if (result.length > 0) {
						that.queueList = result;
						that.view.showQueueModal = true;
					} else that.$Message.error('预约失败!');
				})
			},
			getAppointmentInfoNote() { //获取预约注意事项
				var that=this;
				sysPost(that,{
					"url": 'Common/GetDefaultValue',
					"data": {"DefaultValue": "AppointmentInfoNote"}
				},function(result){
					that.infoNote = result?.dvRemark;
				})
			},
			queueModalColse(){
				this.$router.push({path:'/'})
			}
		},
		components: {
			"v-header": header,
			"v-calendar": calendar,
		}
	}
</script>